/**
 * @file tillPriceSeries.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-20
 * @modified 2026-10-20
 * @description The till's (Epos Now) price intervals as points for the Cost
 *              Price History chart (CostPriceHistoryChart) — its own series
 *              beside the Xero cost (Cam, 20 Oct 2026: "keep both and offer
 *              both"). Pure.
 */

const parseDay = (s) => new Date(String(s).slice(0, 10) + 'T00:00:00');
const DAY_MS = 86400000;

/**
 * The till's intervals as stepped points for one field: a point where each
 * interval starts, a gap (null) where the value is not known, and the last
 * value carried to its interval's end — or to today while it is open.
 * @param {Array<{ from, to, cost, sale_ex_vat }>} intervals  oldest first
 * @param {'cost'|'sale_ex_vat'} field
 * @param {number} todayTs
 */
export function tillStepPoints(intervals, field, todayTs) {
  const out = [];
  const list = (intervals || []).filter(iv => iv && iv.from);
  list.forEach((iv, i) => {
    const v = iv[field] === null || iv[field] === undefined ? null : Number(iv[field]);
    const ts = parseDay(iv.from).getTime();
    const prev = out[out.length - 1];
    // A gap between two intervals' days, or no value: break the line.
    if (prev && prev.y !== null && list[i - 1]?.to && parseDay(list[i - 1].to).getTime() + DAY_MS < ts) {
      out.push({ x: parseDay(list[i - 1].to).getTime(), y: prev.y, recorded: false });
      out.push({ x: parseDay(list[i - 1].to).getTime() + 1, y: null, recorded: false });
    }
    out.push({ x: ts, y: Number.isFinite(v) ? v : null, recorded: Number.isFinite(v) });
    if (i === list.length - 1 && Number.isFinite(v)) {
      const endTs = iv.to ? parseDay(iv.to).getTime() : todayTs;
      if (endTs > ts) out.push({ x: endTs, y: v, recorded: false });
    }
  });
  return out;
}

